import script from "./top-search-form.vue?vue&type=script&setup=true&lang=js"
export * from "./top-search-form.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__